import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { CustomMessageListener } from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class ReloadFrameListener implements CustomMessageListener {
  private readonly document = inject(DOCUMENT);

  messageId(): string {
    return 'general.reload-frame';
  }
  onCustomMessageReceived(
    _customMessage: string,
    _mfObject: any,
    _mfNodesObject: any,
  ): void {
    this.document.defaultView?.location.reload();
  }
}
